import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/ajvirus/Desktop/DTDB_Next/app/social-account-profile/SocialPage.js");
